import React from 'react'

const Footer = () => {
  return (
    <>
    <div className="bg-black w-full  mt-10  text-white text-center p-5">
 
      Copyright © Token Generator by Ahsan 2022
   
</div>

    </>
  )
}

export default Footer